import * as React from 'react';

import { useTranslation } from 'react-i18next';

import gtmTracker from '@utils/gtmTracker';

import { useMutationGetActivityHistory } from '@entities/profile/hooks/use-mutation-get-activity-history.ts';

import { PaginationType, TransactionType } from '@types';

import { Pagination } from '@components/pagination';

const isRockets = config.BRAND === 'rockets';
const isNomad = config.BRAND === 'nomad';
const isJohnny = config.BRAND === 'johnny';
const isVipHouse = config.BRAND === 'com2';
const isSk2 = config.BRAND === 'sk2';
const isNgu3 = config.BRAND === 'ngu3';

import { config } from '@/config.ts';

import * as Styled from './activity-history.styled.ts';
import { Status } from './components/status';

const ActivityHistory = () => {
	const { t } = useTranslation(['main', 'errors', 'activity_history']);
	const [products, setProducts] = React.useState<TransactionType[]>([]);
	const [pagination, setPagination] = React.useState<PaginationType>();
	const { mutate: getHistory, data: historyData } = useMutationGetActivityHistory();

	const [currentPage, setCurrentPage] = React.useState(1);

	const handlePageChange = (page: number) => {
		gtmTracker.trackEvent('click', {
			event_category: 'User_profile',
			event_action: 'Click',
			event_label: 'Pagination'
		});
		setCurrentPage(page);
		getHistory({ page });
	};

	React.useEffect(() => {
		getHistory({ page: currentPage });
	}, [getHistory, currentPage]);

	React.useEffect(() => {
		if (historyData) {
			setPagination(historyData.pagination);
			setProducts(historyData.data);
		}
	}, [historyData]);

	const formatDate = (date: string) => {
		return new Date(date).toLocaleDateString('ru-RU', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		});
	};

	return (
		<Styled.Wrapper>
			<Styled.TableWrapper>
				<Styled.Table>
					<thead>
						<Styled.Head>
							<Styled.HeadItem>{t('activity_history:date')}</Styled.HeadItem>
							<Styled.HeadItem>{t('activity_history:item')}</Styled.HeadItem>
							<Styled.HeadItem>{t('activity_history:amount')}</Styled.HeadItem>
							<Styled.HeadItem>{t('activity_history:status')}</Styled.HeadItem>
						</Styled.Head>
					</thead>
					<Styled.Body>
						{products?.length > 0 &&
							products.map((product, index) => (
								<Styled.BodyItem key={index}>
									<Styled.BodyItemName>{formatDate(product.created_at)}</Styled.BodyItemName>
									<Styled.BodyItemName>
										{product?.shop_item?.name
											? product?.shop_item?.name
											: isRockets || isSk2
												? t('points')
												: isNomad
													? t('n_coins')
													: isJohnny || isVipHouse || isNgu3
														? t('xp_points')
														: t('pmPoints')}
									</Styled.BodyItemName>
									<Styled.BodyItemName>
										{Math.abs(product.amount)} {t('points_p')}
									</Styled.BodyItemName>
									<td>
										<Status transaction={product} />
									</td>
								</Styled.BodyItem>
							))}
					</Styled.Body>
				</Styled.Table>
			</Styled.TableWrapper>
			{pagination && (
				<Styled.PaginationWrapper>
					<Pagination currentPage={currentPage} totalPages={pagination.total_pages} onPageChange={handlePageChange} />
				</Styled.PaginationWrapper>
			)}
		</Styled.Wrapper>
	);
};

export default ActivityHistory;
